// tslint:disable: completed-docs
// Namespaces
export const GET_AND_REFRESH = 'GET_AND_REFRESH';
export const TRACKING = 'TRACKING';
export const WEBCHAT = 'webchat';

/**
 * Message for chat has ended
 */
export const WEBCHAT_HAS_ENDED = 'Der Chat wurde beendet';

/**
 * Message for technical error
 */
export const WEBCHAT_TECHNICAL_ERROR = 'Hoppla! Da hab ich wohl gerade einen Aussetzer. Bitte melde Dich sp&auml;ter nochmal bei mir.';

/**
 * Invalid input
 */
export const WEBCHAT_INVALID_INOUT = 'Ung&uuml;ltige Eingabe, bitte erneut versuchen';
